import { Link } from "react-router-dom";
import { LegalLayout, H2, P, A, UL, Strong } from "@/components/LegalLayout";

const LAST_UPDATED = "June 16, 2026"; // [DATE]
const CONTACT_EMAIL = "privacy@aipathshaalaa.com"; // [EMAIL]

export default function Privacy() {
  return (
    <LegalLayout testid="privacy-page" eyebrow="Legal" title="Privacy Policy" updated={LAST_UPDATED}>
      <P>
        This Privacy Policy explains what information AI Pathshaalaa collects and how we use it. It
        should be read together with our{" "}
        <Link to="/terms" className="text-primary font-semibold underline underline-offset-2">Terms of Service</Link>{" "}
        and our{" "}
        <Link to="/youtube-compliance" className="text-primary font-semibold underline underline-offset-2">YouTube API Services Compliance Policy</Link>.
      </P>

      <H2>1. Information We Collect</H2>
      <UL>
        <li><Strong>Account data</Strong> — your name and email (via email signup or Google sign-in).</li>
        <li><Strong>Learning data</Strong> — your onboarding quiz answers, generated roadmap, lesson progress, quiz scores, notes, and feedback.</li>
        <li><Strong>Usage data</Strong> — basic analytics about how you use the Platform (pages viewed, features used).</li>
      </UL>

      <H2>2. YouTube API Services &amp; Google</H2>
      <P>
        AI Pathshaalaa uses YouTube API Services to discover and embed videos. Our use of information
        from YouTube API Services is subject to the{" "}
        <A href="https://policies.google.com/privacy">Google Privacy Policy</A>. When a video plays,
        it streams from YouTube's official player; YouTube may process data in accordance with its own
        policies and the <A href="https://www.youtube.com/t/terms">YouTube Terms of Service</A>. We
        embed videos in privacy-enhanced (no-cookie) mode and disable personalized data collection on
        any content marked "Made for Kids".
      </P>

      <H2>3. How We Use Your Information</H2>
      <UL>
        <li>To build and personalize your learning roadmap and recommendations.</li>
        <li>To generate AI summaries and quizzes and to track your progress.</li>
        <li>To operate, secure, and improve the Platform.</li>
      </UL>
      <P><Strong>We do not sell your personal information.</Strong></P>

      <H2>4. YouTube Data Retention</H2>
      <P>
        We store only YouTube <Strong>metadata</Strong> (such as titles, channel names, thumbnails,
        and view counts) needed to assemble courses — never the videos themselves. In line with
        YouTube's requirements, this stored API data is automatically refreshed or deleted within 30
        days, and any video that is removed or made private on YouTube is removed from our Platform.
      </P>

      <H2>5. Cookies &amp; Analytics</H2>
      <P>
        We use essential cookies for authentication and may use privacy-respecting analytics to
        understand product usage. You can control cookies through your browser settings.
      </P>

      <H2>6. Data Retention &amp; Your Choices</H2>
      <P>
        We keep your account and learning data for as long as your account is active. You may request
        access to, correction of, or deletion of your data by contacting us at{" "}
        <Strong>{CONTACT_EMAIL}</Strong>.
      </P>

      <H2>7. Contact</H2>
      <P>For privacy questions or data requests, email <Strong>{CONTACT_EMAIL}</Strong>.</P>
    </LegalLayout>
  );
}
